import { local_storage_keys } from '@/constants/localstorage'
import * as React from 'react'
import { useState, useEffect } from 'react'

export const ConversationContext = React.createContext({
  ticketInfo: [],
  setTicketInfo: (key: any) => [],
  setMessage: (key: any) => {},
  setFile: (key: any) => {},
})

const ConvesationTicketProvider = (props: any) => {
  const locale_data = JSON.parse(
    localStorage.getItem(local_storage_keys.CONVERSATION_TICKET) ?? '[]',
  )
  const [ticketInfo, setTicketInfo] = useState<any>(
    locale_data.ticketInfo ?? [],
  )
  const [message, setMessage] = useState<any>(locale_data.ticketInfo ?? '')
  const [file, setFile] = useState<any>(locale_data.ticketInfo ?? '')

  const conversationTicketContext = {
    ticketInfo: ticketInfo,
    setTicketInfo: setTicketInfo,
    message: message,
    setMessage: setMessage,
    file: file,
    setFile: setFile,
  }

  useEffect(() => {
    const data_storage = {
      ticketInfo,
      message,
      file,
    }
    localStorage.setItem(
      local_storage_keys.CONVERSATION_TICKET,
      JSON.stringify(data_storage),
    )
  }, [ticketInfo, message, file])

  return (
    <ConversationContext.Provider value={conversationTicketContext}>
      {props.children}
    </ConversationContext.Provider>
  )
}

export default ConvesationTicketProvider
